<!-- Header -->
<p-toast></p-toast>
<header class="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md shadow-sm z-50">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between items-center h-16">
            <!-- Logo Section -->
            <div class="flex items-center space-x-3">
                <img src="/assets/images/logos/Hector_Group_Logo_Black.jpg" alt="Hector Group Logo" class="w-16 h-16 rounded-full object-cover" />
                <div>
                    <span class="text-xl font-bold text-gray-900">Hector Global</span>
                    <div class="text-xs text-amber-600 font-medium">Investment Institution</div>
                </div>
            </div>

            <!-- Desktop Navigation -->
            <nav class="hidden lg:flex space-x-6 xl:space-x-8">
                <button (click)="scrollToSection('home')" class="cursor-pointer text-gray-700 hover:text-amber-600 transition-colors text-sm xl:text-base">
                    Home
                </button>
                <button (click)="scrollToSection('services')" class="cursor-pointer text-gray-700 hover:text-amber-600 transition-colors text-sm xl:text-base">
                    Investment Opportunities
                </button>
                <button (click)="scrollToSection('testimonials')" class="cursor-pointer text-gray-700 hover:text-amber-600 transition-colors text-sm xl:text-base">
                    Testimonials
                </button>
                <button (click)="scrollToSection('calculator')" class="cursor-pointer text-gray-700 hover:text-amber-600 transition-colors text-sm xl:text-base">
                    ROI Calculator
                </button>
                <button (click)="scrollToSection('contact')" class="cursor-pointer text-gray-700 hover:text-amber-600 transition-colors text-sm xl:text-base">
                    Global Offices
                </button>
            </nav>

            <!-- Desktop Action Buttons -->
            <div *ngIf="!isAuthenticated" class="hidden lg:flex items-center space-x-3 xl:space-x-4">
                <button (click)="openLogin('login')" class="text-gray-700 hover:text-amber-600 transition-colors text-sm xl:text-base">
                    Login
                </button>
                <button (click)="openLogin('signup')" class="bg-gradient-to-r from-amber-500 to-amber-600 text-white px-4 xl:px-6 py-2 rounded-lg hover:from-amber-600 hover:to-amber-700 transition-all shadow-lg text-sm xl:text-base">
                    Start Investing
                </button>
            </div>
            <div *ngIf="isAuthenticated" class="hidden lg:flex items-center space-x-3 xl:space-x-4">
                <button (click)="  navigateToDashboard()" class="cursor-pointer bg-gradient-to-r from-amber-500 to-amber-600 text-white px-4 xl:px-6 py-2 rounded-lg hover:from-amber-600 hover:to-amber-700 transition-all shadow-lg text-sm xl:text-base">
                    Dashboard
                </button>
            </div>

            <!-- Mobile Menu Toggle -->
            <button class="lg:hidden flex items-center justify-center" (click)="toggleMobileMenu()">
                <i-lucide 
                    [name]="isMenuOpen ? 'x' : 'menu'" 
                    class="h-6 w-6 text-gray-700"
                ></i-lucide>
            </button>
        </div>
    </div>

    <!-- Mobile Menu -->
    <div *ngIf="isMenuOpen" class="lg:hidden bg-white border-t">
        <div class="px-2 pt-2 pb-3 space-y-1">
            <button (click)="scrollToSection('home')" class="block w-full text-left px-3 py-2 text-gray-700 hover:text-amber-600">
                Home
            </button>
            <button (click)="scrollToSection('services')" class="block w-full text-left px-3 py-2 text-gray-700 hover:text-amber-600">
                Investment Opportunities
            </button>
            <button (click)="scrollToSection('testimonials')" class="block w-full text-left px-3 py-2 text-gray-700 hover:text-amber-600">
                Testimonials
            </button>
            <button (click)="scrollToSection('calculator')" class="block w-full text-left px-3 py-2 text-gray-700 hover:text-amber-600">
                ROI Calculator
            </button>
            <button (click)="scrollToSection('contact')" class="block w-full text-left px-3 py-2 text-gray-700 hover:text-amber-600">
                Global Offices
            </button>
           <div *ngIf="!isAuthenticated" class="px-3 py-2 flex flex-col items-start g-2 ">
                <button (click)="openLogin('login')" class="text-gray-700 hover:text-amber-600 transition-colors mb-3">
                    Login
                </button>
                <button (click)="openLogin('signup')" class="bg-gradient-to-r from-amber-500 to-amber-600 text-white px-6 py-2 rounded-lg hover:from-amber-600 hover:to-amber-700 transition-all shadow-lg">
                    Start Investing
                </button>
            </div>
            <div *ngIf="isAuthenticated" class="px-3 py-2">
                <button (click)="navigateToDashboard()" class="cursor-pointer w-full bg-gradient-to-r from-amber-500 to-amber-600 text-white px-6 py-2 rounded-lg hover:from-amber-600 hover:to-amber-700 transition-all shadow-lg">
                   Dashboard
                </button>
            </div>
        </div>
    </div>
</header>
<router-outlet />

<app-user-login *ngIf="showLoginModal" [isLogin]="loginMode === 'login'" (onLogin)="handleLogin($event)" (onClose)="handleClose()">
</app-user-login>